import { AssignmentStatsInput, ContentEntity } from '@/types/schema';

import { useAssignmentStatsQuery } from '../../graphql/queries/generated/assignmentStats';

const CONTENT_VISIBILITY_ISSUE_ERROR_CODE = 'CONTENT_VISIBILITY_ISSUE';

export default function useAssignmentStats({
  filters,
  pause,
}: {
  filters: AssignmentStatsInput;
  pause?: boolean;
}) {
  const [{ fetching: fetchingAssignmentStats, data }] = useAssignmentStatsQuery({
    variables: {
      filters,
    },
    pause,
  });

  return {
    fetching: fetchingAssignmentStats,
    contentsCount: data?.assignmentStats.contentCount,
    learnersCount: data?.assignmentStats.userCount,
    notVisibleContents: data?.assignmentStats.notVisibleContents
      ? (data.assignmentStats.notVisibleContents as ContentEntity[])
      : undefined,
    canAssign: data?.assignmentStats.errorMessage !== CONTENT_VISIBILITY_ISSUE_ERROR_CODE,
  };
}
